import React, { useEffect, useRef, useState } from "react";
import EditCategory from "../EditCategory";
import { VideoCategoryProps } from "../../store/actionType";
import { connect, useSelector } from "react-redux";
import { deleteVideoCategory } from "../../store/action";
import FolderCard from "modules/video/components/FolderCard";
import MenuDropdown from "modules/video/components/MenuDropdown";
import { SmallScreenModel } from "components";
import ConfirmationDialogMsg from "modules/video/components/ConfirmationDialogMsg";
import { Authorities } from "props/authoritries";
import { useUser } from "utils/helpers/UserContext";
import { SuperAdminStatusEnum } from '../../../../../props/enum';

interface CategoryProps {
  categoryData: VideoCategoryProps;
  onClick: () => void;
}

type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = DispatchProps & CategoryProps;

const CategoryCard: React.FC<Props> = ({
  categoryData,
  onClick,
  onDeleteVideoCategory,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isEidtFormOpen, setIsEidtFormOpen] = useState(false);
  const [isDeleteDialogOpen, setIsDeleteDialogOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  const categoriesState = useSelector(
    (state: any) => state.videoCategories.videoCategoriesState
  );
  const [deleteError, setDeleteError] = useState(null);
  const closeModal = () => {
    setIsEidtFormOpen(false);
  };
  const handleMenuClick = (e: any) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleCategoryClick = () => {
    if (!isMenuOpen) {
      onClick();
    } else {
      setIsMenuOpen(!isMenuOpen);
    }
  };
  const handleCopyCategoryId = (e: any) => {
    e.stopPropagation();
    navigator.clipboard.writeText(categoryData.id);
  };

  const handleDeleteCategory = (e: any) => {
    e.stopPropagation();
    onDeleteVideoCategory(categoryData.id, categoryData.folder_id);
    setDeleteError(null);
  };

  const toggleEditModal = () => {
    setIsEidtFormOpen(!isEidtFormOpen);
  };

  const toggleDeleteDialog = () => {
    setIsDeleteDialogOpen(!isDeleteDialogOpen);
  };

  useEffect(() => {
    const handleClickOutside = (event: { target: any }) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);

  useEffect(() => {
    setDeleteError(categoriesState.delete);
    if (categoriesState.delete === null) {
      setIsDeleteDialogOpen(false);
    }
  }, [categoriesState.delete]);
  const { authUser, action, superAdmin } = useUser();
  const isPermitted =
    authUser &&
    (superAdmin === SuperAdminStatusEnum.SuperAdmin  ||
      action?.includes(Authorities.UPDATE_CATEGORY));
  return (
    <>
      <FolderCard
        ref={ref}
        clickedFolder={handleCategoryClick}
        clickedMenu={handleMenuClick}
        title={categoryData.name}
        description={categoryData?.description}
        orderNumber={categoryData?.category_order}
      >
        {isMenuOpen && (
          <>
            {isPermitted ? (
              <MenuDropdown
                clickedEdit={toggleEditModal}
                copyId={categoryData.id}
                clickedDelete={toggleDeleteDialog}
              />
            ) : (
              <div className="text-primary-400 text-center h-[30vh] w-[20vw] flex justify-center items-center">
                You don't have the permission.
              </div>
            )}
          </>
        )}
      </FolderCard>
      <SmallScreenModel
        showModal={isEidtFormOpen}
        setShowModal={setIsEidtFormOpen}
      >
        <EditCategory closeModal={closeModal} categoryData={categoryData} />
      </SmallScreenModel>
      <SmallScreenModel
        showModal={isDeleteDialogOpen}
        setShowModal={setIsDeleteDialogOpen}
      >
        <ConfirmationDialogMsg
          title={"Delete Category"}
          message={"Are you sure you want to delete?"}
          onConfirm={handleDeleteCategory}
          onCancel={toggleDeleteDialog}
          error={deleteError}
          folderName={categoryData.name}
        />
      </SmallScreenModel>
    </>
  );
};

const mapDispatchToProps = (dispatch: any) => ({
  onDeleteVideoCategory: (category_id: string, folder_id: string) =>
    dispatch(deleteVideoCategory(category_id, folder_id)),
});

export default connect(null, mapDispatchToProps)(CategoryCard);
